<template>
	<v-sheet v-if="navigationDrawerApps.open" v-closable="{handler: 'onClose'}" class="profileDropdown">
		<v-list class="pa-0">
			<v-list two-line class="pa-0">
				<v-list-item-group :value="activeApp" color="primary">
					<v-list-item @click="redirectToPortal(item.path)" class="px-6 pb-2" v-for="item in navigationDrawerApps.items" :key="item.id">
						<v-list-item-icon class="d-flex align-self-center my-0 pl-1">
							<v-icon>{{ item.icon }}</v-icon>
						</v-list-item-icon>
						<v-list-item-content class="d-flex align-self-center pt-1 pb-0">
							<v-list-item-title>{{ item.name }}</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list-item-group>
			</v-list>
		</v-list>
	</v-sheet>
</template>

<style scoped lang="sass">
	.profileDropdown
		position: absolute
		top: 64px
		right: 0
		width: 320px
		box-shadow: 0 16px 24px rgba(0,0,0,0.20)
</style>

<script>
	import jwt from 'jsonwebtoken'

	export default {
		name: 'NavigationDrawerApps',
		props: {
			navigationDrawerApps: {
				type: Object,
				default: () => ({
					open: false,
					title: 'Applications',
					items: []
				})
			},
			userDataRoles: Array,
		},
		data() {
			return {
				user: null,
				activeApp: 1,
			};
		},
		mounted() {
			this.fetchUserData();
		},
		methods: {
			onClose() {
				this.navigationDrawerApps.open = false
			},
			fetchUserData() {
				try {
					const token = JSON.parse(localStorage.getItem('access_token'));
					const decodedToken = jwt.decode(token);
					const isAdvisor = decodedToken?.isAdvisor;

					this.processUserData(isAdvisor);
				} catch (e) {
					return e
				}
			},
			processUserData(isAdvisor) {
				if (!isAdvisor || !this.userDataRoles?.length) return

				const accessibleAppsIds = new Set();
				const accessibleApps = [];

				if (this.userDataRoles.length > 0) {
					this.userDataRoles.forEach(role => {
						if (role.application && Array.isArray(role.application)) {
							role.application.forEach(app => {
								if (!accessibleAppsIds.has(app.id) && !app.name.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().includes('examenes')) {
									accessibleAppsIds.add(app.id);
									accessibleApps.push(app);
								}
							})
						}});
					}

				if (accessibleApps.length <= 1) return

				this.navigationDrawerApps.visible = true
				this.navigationDrawerApps.items = Array.from(accessibleApps).map((app, i) => {
					if (app.domain == window.location.host) this.activeApp = i
					return { id: app.id, name: app.name, icon: app.icon || 'mdi-monitor-dashboard', path: app.domain }
				})
			},
			redirectToPortal(redirect) {
				try {
					const params = {
						access_token: JSON.parse(localStorage.getItem('access_token')), 
						refresh_token: (JSON.parse(localStorage.getItem('refresh_data'))).token, 
						expires_in: (JSON.parse(localStorage.getItem('refresh_data'))).expires,
					}
					
					const redirect_path = new URL(`https://${redirect}/login-sso`)

					Object.keys(params).forEach(key => {
						redirect_path.searchParams.append(key, params[key]);
					});
					
					window.open(redirect_path, '_blank');
					
				} catch (e) {
					return e;
				}
			},
		},
	}
</script>  